import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { SimpleEventsQueryResource } from '../models/resources/simpleEventsQueryResource.model';
import {Subject} from 'rxjs';


@Injectable()
export class GlobalIntegrationService {
  private aws = environment.aws;

  private _oauthPayload: any;
  private _simpleEventsQueryResource: SimpleEventsQueryResource;

  // TODO: remove this
  private _eventsQuerySearchEventEmitter: Subject<any> = new Subject<any>();
  private _eventsQuerySaveEventEmitter: Subject<any> = new Subject<any>();

  private _eventsEmailButtonClickEventEmitter: Subject<any> = new Subject<any>();
  private _eventsEmailSendEventEmitter: Subject<any> = new Subject<any>();

  private _savedQueryLoadEventEmitter: Subject<any> = new Subject<any>();

  private _emailPanelRequestEventEmitter: Subject<any> = new Subject<any>();
  private _emailPanelResponseEventEmitter: Subject<any> = new Subject<any>();

  private _paginationChangeEventEmitter: Subject<any> = new Subject<any>();
  private _calendarHeaderSortChangeEventEmitter: Subject<any> = new Subject<any>();

  get oauthPayload(): any {
    return this._oauthPayload;
  }

  set oauthPayload(value: any) {
    this._oauthPayload = value;
  }

  get simpleEventsQueryResource(): SimpleEventsQueryResource {
    return this._simpleEventsQueryResource;
  }

  set simpleEventsQueryResource(value: SimpleEventsQueryResource) {
    this._simpleEventsQueryResource = value;
  }

  get eventsQuerySearchEventEmitter(): Subject<any> {
    return this._eventsQuerySearchEventEmitter;
  }

  set eventsQuerySearchEventEmitter(value: Subject<any>) {
    this._eventsQuerySearchEventEmitter = value;
  }

  get eventsQuerySaveEventEmitter(): Subject<any> {
    return this._eventsQuerySaveEventEmitter;
  }

  set eventsQuerySaveEventEmitter(value: Subject<any>) {
    this._eventsQuerySaveEventEmitter = value;
  }

  get eventsEmailButtonClickEventEmitter(): Subject<any> {
    return this._eventsEmailButtonClickEventEmitter;
  }

  set eventsEmailButtonClickEventEmitter(value: Subject<any>) {
    this._eventsEmailButtonClickEventEmitter = value;
  }

  get eventsEmailSendEventEmitter(): Subject<any> {
    return this._eventsEmailSendEventEmitter;
  }

  set eventsEmailSendEventEmitter(value: Subject<any>) {
    this._eventsEmailSendEventEmitter = value;
  }

  get savedQueryLoadEventEmitter(): Subject<any> {
    return this._savedQueryLoadEventEmitter;
  }

  set savedQueryLoadEventEmitter(value: Subject<any>) {
    this._savedQueryLoadEventEmitter = value;
  }

  get emailPanelRequestEventEmitter(): Subject<any> {
    return this._emailPanelRequestEventEmitter;
  }

  set emailPanelRequestEventEmitter(value: Subject<any>) {
    this._emailPanelRequestEventEmitter = value;
  }

  get emailPanelResponseEventEmitter(): Subject<any> {
    return this._emailPanelResponseEventEmitter;
  }

  set emailPanelResponseEventEmitter(value: Subject<any>) {
    this._emailPanelResponseEventEmitter = value;
  }

  get paginationChangeEventEmitter(): Subject<any> {
    return this._paginationChangeEventEmitter;
  }

  set paginationChangeEventEmitter(value: Subject<any>) {
    this._paginationChangeEventEmitter = value;
  }

  get calendarHeaderSortChangeEventEmitter(): Subject<any> {
    return this._calendarHeaderSortChangeEventEmitter;
  }
}
